import Box from '@mui/material/Box';
import React from 'react';
import type { FC, PropsWithChildren } from 'react';

const ContainerContent: FC<PropsWithChildren> = ({
  children,
}) => {
  return <Box>{children}</Box>;
};

export default ContainerContent;
